import { StyleSheet } from 'react-native';

import { C } from 'common';
import { ENV, LAYOUT, THEME } from 'reactor/common';

const { LAYOUT: { ASIDE, HEADER } } = C;
const { COLOR, ELEVATION, SPACE } = THEME;

const { VIEWPORT: { PORTRAIT } } = LAYOUT;

export default StyleSheet.create({
  container: {
    paddingTop: HEADER.HEIGHT + SPACE.REGULAR,
    position: ENV.IS_WEB ? 'fixed' : 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    backgroundColor: COLOR.WHITE,
    width: !PORTRAIT ? ASIDE.WIDTH : '100%',
    zIndex: 1,
  },

  elevation: { ...ELEVATION.REGULAR },

  item: {
    ...LAYOUT.STYLE.ROW,
    paddingHorizontal: SPACE.REGULAR,
    paddingTop: SPACE.REGULAR,
  },

  icon: {
    marginRight: SPACE.XS,
  },

  visible: {
    backgroundColor: 'orange',
  },

  title: {
    color: COLOR.TEXT,
    paddingTop: SPACE.XS,
    paddingHorizontal: SPACE.REGULAR,
  },
});
